import updateRoleApi from 'api/menus/updateRoleApi';
import { Type } from '../const';
import updateTabApi from 'api/menus/updateTabApi';
import updateSubTabApi from 'api/menus/updateSubTabApi';

/**
 * @function separateByGroupId
 * @param { array } values
 * @returns { array }
 */
function separateByGroupId(values) {
	const results = values.reduce((accu, value) => {
		const { groupId } = value;
		if (accu[groupId] === null || accu[groupId] === undefined) {
			accu[groupId] = [];
		}
		accu[groupId].push(value);
		return accu;
	}, {});

	const _results = Object.entries(results).map((value) => {
		return { groupId: value[0], values: value[1] };
	});

	return _results;
}

/**
 * @function updateSavingData
 * @param { object } data
 * @returns { void }
 */
function updateSavingData(data) {
	const newData = Object.assign({}, data);

	if (newData[Type.Tabs]) {
		const tabs = [...newData[Type.Tabs]];
		const results = separateByGroupId(tabs);
		results.forEach((result) => updateTabApi(result.values));
	}

	if (newData[Type.Subtabs]) {
		let subtabs = [...newData[Type.Subtabs]];
		const results = separateByGroupId(subtabs);
		results.forEach((result) => updateSubTabApi(result.values));
	}

	if (newData[Type.Roles]) {
		const roles = [...newData[Type.Roles]];
		const results = separateByGroupId(roles);
		results.forEach((result) => updateRoleApi(result.values));
	}
}

export default updateSavingData;
